import { useState } from 'react';

export default function useToken() {
  
  const saveTimeZone = timeZone => {
    if (timeZone) {
      localStorage.setItem('time-zone', timeZone);
      setTimeZone(timeZone)
    }
  }
  
  const getTimeZone = () => {
    var timeZoneStr = localStorage.getItem('time-zone')
    if (!timeZoneStr) {
      return parseInt((new Date()).getTimezoneOffset() / -60)
    }
    return parseInt(timeZoneStr)
  }

  const [timeZone, setTimeZone] = useState(getTimeZone());


  return {
    setTimeZone: saveTimeZone,
    timeZone
  }
}